import { MainCtaButton } from "../../../../views/components/MainCtaButton";
import { IndustryHeroImage } from "./IndustryHeroImage";
import Image from "next/image";
import clsx from "clsx";

export const IndustryHero = ({ title, description, img, images, className }) => {
  return (
    <section className={clsx("industry_hero-background", className)}>
      <div className="industry_hero">
        <section className="section-layout">
          <h1>{title}</h1>
          <p className="industry_hero-text">{description}</p>
          <MainCtaButton autoWidth data-test-id="industry_hero-button" />

          <div className="industry_hero-main_image">
            <div className="industry_hero-images_container">
              {images.mainSection.map(({ id, img, alt }) => {
                return <IndustryHeroImage key={id} img={img} alt={alt} />;
              })}
            </div>
          </div>
          <p className={`home_hero-small_text ${!img && "margin"}`}>
            Join the customers already unlocking the power of external data with Demyst
          </p>
          <div className="industry_hero-providers">
            {images.footerSection.map(({ id, img, alt, width, height }) => {
              return (
                <Image key={id} src={img.src} alt={alt} width={width} height={height} priority />
              );
            })}
          </div>
        </section>
      </div>
    </section>
  );
};
